
const state = {
  isLoading: false,
  loader: 'bars',
}

const mutations = {
  setLoadingStatus(state, status){
    state.isLoading = status.loading
    state.loader = status.loader ? 'bars' : status.loader
  },
  clearLoading(state){
    state.isLoading = false
    state.loader = 'bars'
  }
}

export default {
  namespaced: true,
  state,
  mutations,
}